import { Component, computed, effect, inject, input, output, ViewChild } from '@angular/core';
import { TableModule } from '@openng/optimus-ui/table';
import { TranslatePipe } from '@ngx-translate/core';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { isAllowed } from '../../../../../modules/shared/shared.global-service';
import { TableColumn } from '../../../../../modules/shared/components/kit/table/table.types';
import { TableComponent } from '../../../../../modules/shared/components/kit/table/table.component';
import { FolderEPrescriptionsListStore } from './folder-e-prescriptions-list.store';
import {
    MedicationInfoComponent,
} from '../../../../../modules/shared/components/kit/medication-info/medication-info.component';
import { LocalDatePipe } from '../../../../../modules/shared/pipes/local-date.pipe';
import { EPrescriptionObject } from '@libs/types/src/services/object-type/sukl/e-prescription.object';

@Component({
    selector: 'app-folder-e-prescriptions-list',
    templateUrl: 'folder-e-prescriptions-list.component.html',
    styleUrls: ['folder-e-prescriptions-list.component.scss'],
    providers: [FolderEPrescriptionsListStore],
    imports: [
        TableModule,
        TranslatePipe,
        PrimeTemplate,
        TableComponent,
        MedicationInfoComponent,
        LocalDatePipe,
    ],
})
export class FolderEPrescriptionsListComponent {

    public readonly store = inject(FolderEPrescriptionsListStore);

    public selectedId = input<number>(-1);
    public selectedChanged = output<EPrescriptionObject | null>();

    @ViewChild('ePrescriptions')
    protected ePrescriptions!: TableComponent;
    protected prefix = 'ePrescriptions.';

    protected items = computed(() => {
        return [
            {
                id: -1,
                issuedAt: new Date(),
                __hideDelete: true,
            },
            ...(this.store.data.getEPrescriptions()?.items || []),
        ];
    });

    protected columns: TableColumn[] = [
        { name: 'issuedAt' },
        // { name: 'status' }, // TODO later
        { name: 'medications' },
    ];

    constructor() {
        effect(() => {
            this.ePrescriptions?.clearSelection();
            setTimeout(() => {
                this.ePrescriptions?.select(this.items()[0]);
            }, 10);
        });
        this.store.onSuccess(
            () => {
                this.store.refreshData();
            },
            'createEPrescription',
        );
    }

    protected selection(event: EPrescriptionObject | null): void {
        this.selectedChanged.emit(event);
    }

    protected delete(event: any): void {

    }

    protected readonly isAllowed = isAllowed;

}
